import { Loader, Select, Stack, TextInput } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { useEffect } from "react";
import { useOptInUserFormContext } from "shared/components/opt-in/context";
import { useFormState } from "shared/hooks/useFormState";
import { useOptInUserMutation } from "shared/hooks/useGraphql";
import { fail, titlecase } from "shared/utils/fns";
import { notify } from "shared/utils/notify";
import { graphql } from "src/gql";
import { Language } from "src/gql/graphql";

export const LanguageAndNameSelector = () => {
    const form = useOptInUserFormContext();
    const [userId] = useFormState(form, "id");
    const [name] = useFormState(form, "name");
    const [customer] = useFormState(form, "customer");
    const [language] = useFormState(form, "language");

    const [newName, setNewName] = useDebouncedState(name, 500);

    const updateLanguageAndName = useOptInUserMutation(
        graphql(`
            mutation OptInSettingsUpdateNameAndLanguage($params: UpdateUserParametersInput!, $userId: UUID!) {
                updateUser(params: $params, userId: $userId) {
                    id
                }
            }
        `),
    );

    useEffect(() => {
        if (newName == name || !newName?.length || !userId) return;
        updateLanguageAndName
            .mutateAsync({ params: { name: newName, language }, userId })
            .then(() => {
                form.setFieldValue("name", newName);
                notify.show.success("Updated name");
            })
            .catch(notify.catch);
    }, [newName]);

    return (
        <Stack>
            <TextInput
                label="Name"
                defaultValue={name}
                onChange={(e) => setNewName(e.target.value)}
                rightSection={newName != name ? <Loader size={16} /> : null}
                w={250}
            />
            <Select
                label="Language"
                data={customer.languages.map((lang) => ({ label: titlecase(lang), value: lang }))}
                defaultValue={language}
                w={250}
                onChange={(lang) => {
                    if (!userId) return fail("Opt-in ID not found");
                    updateLanguageAndName
                        .mutateAsync({ params: { language: lang as Language, name: name ?? "" }, userId })
                        .then(() => {
                            form.setFieldValue("language", lang as Language);
                            notify.show.success("Updated language");
                        })
                        .catch(notify.catch);
                }}
                allowDeselect={false}
            />
        </Stack>
    );
};
